module.exports = __webpack_public_path__ + "static/media/Calculator_Hero_Tablet.028457c2.png";